import { useState } from 'react';
import AuthLayout from './layout/LeftPanel';
import Stepper from './components/Stepper';
import DeviceValidation from './steps/DeviceValidation';
import CompanyDetails from './steps/CompanyDetails';
import Compliance from './steps/Compliance';

const SignupContainer = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});

  const next = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
    setStep((prev) => prev + 1);
  };

  const back = () => setStep((prev) => prev - 1);

  const renderStep = () => {
    switch (step) {
      case 1:
        return <DeviceValidation next={next} />;
      case 2:
        return <CompanyDetails next={next} back={back} />;
      case 3:
        return <Compliance back={back} data={formData} />;
      default:
        return null;
    }
  };

  return (
    <AuthLayout>
      <Stepper step={step} />
      {renderStep()}
    </AuthLayout>
  );
};

export default SignupContainer;
